import * as React from 'react';
import { Component, useState, useEffect, useCallback, useRef, useMemo } from 'react'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import { useAuth, apiFetch } from "../hooks/useAuth";

import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import ListItemText from '@mui/material/ListItemText';
// removed bulk select header
import { SelectElement } from 'react-hook-form-mui';

export function AccountSelect(props) {
    let sx = props.sx;
    const { claims, accountID, changeAccountID, customerNames } = useAuth();

    const handleChange = (selectedId) => {
        // Handler for when user selects an account
        // The form will handle the actual value change
    };



    // Prepare options for SelectElement with customer names
    // Use useMemo to ensure options update when customerNames changes
    const options = useMemo(() => [
        { id: '', label: 'Bitte wählen' },
        ...((claims?.aid?.split(",").map(aid => {
            const trimmedAid = aid.trim();
            return {
                id: trimmedAid, 
                label: customerNames[trimmedAid] ? `${trimmedAid} (${customerNames[trimmedAid]})` : trimmedAid 
            };
        }) || []))
    ], [claims?.aid, customerNames]);

    return (
        <SelectElement
            key={`account-select-${Object.keys(customerNames).length}`}
            sx={{ ...sx, minWidth: 300 }}
            name="accountID"
            label="Kunden-Nr."
            required={true}
            options={options}
            fullWidth
            size="small"
            parseError={() => 'Dieses Feld ist erforderlich'}
            disabled={options.length === 0}
            placeholder="Bitte wählen"
            onChange={handleChange}
        />
    );
}


export function AccountSelectCheck(props) {
    let sx = props.sx;
    const { user, claims, accountID, changeAccountID, customerNames } = useAuth();

    // Use accountID from useAuth as the source of truth
    const [selectedValues, setSelectedValues] = useState(accountID || []);
    const debounceTimer = useRef(null);
    
    // Sync local state with accountID from useAuth
    useEffect(() => {
        if (accountID && accountID.length > 0) {
            // console.log("AccountSelect - Syncing with accountID from useAuth:", accountID);
            setSelectedValues(accountID);
        }
    }, [accountID]);

    // Cleanup debounce timer on unmount
    useEffect(() => {
        return () => {
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }
        };
    }, []);


    const handleChange = (event) => {
        const newValue = event.target.value;
        // console.log("AccountSelect - User changed selection to:", newValue);

        // Update local state immediately for responsive UI
        setSelectedValues(newValue);

        // Save selection to localStorage for persistence
        try {
            localStorage.setItem('selectedAccounts', JSON.stringify(newValue));
            // console.log("AccountSelect - Saved to localStorage:", newValue);
        } catch (error) {
            console.warn("Error saving account selection:", error);
        }
        
        // Debounce the global accountID update (500ms)
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }
        
        debounceTimer.current = setTimeout(() => {
            // console.log("AccountSelect - Applying debounced update:", newValue);
            changeAccountID(newValue);
        }, 500);
    };

    // removed bulk select handlers

    return (
        <FormControl variant="outlined" fullWidth sx={{ marginRight: '1rem', minWidth: '120px' }}>
                <InputLabel id="demo-multiple-checkbox-label">Kundennummer</InputLabel>
                <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={selectedValues}
                onChange={handleChange}
                label="Kundennummer"
                MenuProps={{
                    PaperProps: {
                        style: {
                            maxHeight: 300,
                        },
                    },
                }}
                renderValue={(selected) => {
                    // console.log("renderValue called with:", selected);
                    // console.log("customerNames:", customerNames);
                    return `ausgewählt (${selected.length})`;
                }}
            >
                
                {/* Individual customer options */}
                {claims?.aid?.split(",").map((kdnr) => {
                    const trimmedKdnr = kdnr.trim();
                    const name = customerNames[trimmedKdnr];
                    const displayText = name ? `${trimmedKdnr} (${name})` : trimmedKdnr;
                    const isChecked = selectedValues.indexOf(trimmedKdnr) > -1;
                    // console.log(`Dropdown option for ${trimmedKdnr}:`, displayText, 'checked:', isChecked);
                    return (
                        <MenuItem key={trimmedKdnr} value={trimmedKdnr}>
                            <Checkbox checked={isChecked} />
                            <ListItemText primary={displayText} />
                        </MenuItem>
                    );
                })}
                </Select>
        </FormControl>
    );
}